import VueShepherdPlugin from "vue-shepherd";
import "shepherd.js/dist/css/shepherd.css";
import "@/styles/siteTour.scss";

const SiteTour = VueShepherdPlugin;
export default SiteTour;
